import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {PaymentService} from '../../shared/services/payment.service';
import {Subject} from 'rxjs';
import {PaymentCreate} from 'src/app/shared/models/payment.model';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {takeUntil} from 'rxjs/operators';

declare var SqPaymentForm: any;


@Component({
    selector: 'form-payment-square',
    styleUrls: ['./form-payment-square.scss'],
    templateUrl: 'form-payment-square.html'
})
export class FormPaymentSquareComponent implements OnInit, OnDestroy, AfterViewInit {

    @Input() amount: number;
    @Input() reservation_id: number;

    paymentForm;
    paymentAmountForm: FormGroup;

    is_change_amount: boolean;

    // Set the application ID
    applicationId = 'sq0idp-QrIphaqSRw8oNpAjwhIMXA';

    // Set the location ID
    locationId = '9P8E1QH5CQWHG';
    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private http: HttpClient, private paymentService: PaymentService) {
        this.is_change_amount = false;
    }

    ngOnInit() {
        this.paymentAmountForm = new FormGroup({
            'amount': new FormControl(this.amount),
            'new_amount': new FormControl()
        });

        this.paymentAmountForm.get('new_amount').valueChanges
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (value) => {
                this.amount = value;
                this.paymentAmountForm.get('amount').setValue(value);
            }
        );

        this.paymentService.paymentProcessEmitter
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            () => {
                /*   (<HTMLInputElement>document.getElementById('sq-creditcard')).click();*/
                (<HTMLInputElement>document.getElementById('card-button')).click();
            }
        );
    }

    // Call this function to send a payment token, buyer name, and other details
    // to the project server code so that a payment can be created with
    // Payments API
    async createPayment(token) {
        return this.http.post('https://server.ozshuttle.com/api/extras/process_payment_square.php'
            , {locationId: this.locationId, sourceId: token, amount: this.amount}
            ).subscribe(
            responseData => {
                if (responseData['payment']['id']) {
                    const payment = responseData['payment'];
                    const new_payment = new PaymentCreate(null, null, payment['total_money']['amount'] / 100, 'Credit Card',
                        payment['card_details']['card']['card_brand'], payment['card_details']['card']['last_4'],
                        payment['id'], payment['receipt_number']);
                    this.paymentService.paymentChanged.next(new_payment);
                }
            }, error => {
                this.onSubmitError();
                console.log(error);
            });
    }


    // Helper method for displaying the Payment Status on the screen.
    // status is either SUCCESS or FAILURE;
    displayPaymentResults(status) {
        const statusContainer = document.getElementById(
            'payment-status-container'
        );
        if (status === 'SUCCESS') {
            statusContainer.classList.remove('is-failure');
            statusContainer.classList.add('is-success');
        } else {
            statusContainer.classList.remove('is-success');
            statusContainer.classList.add('is-failure');
        }

        statusContainer.style.visibility = 'visible';
    }

    async tokenize(paymentMethod) {
        const tokenResult = await paymentMethod.tokenize();
        if (tokenResult.status === 'OK') {
            return tokenResult.token;
        } else {
            let errorMessage = `Tokenization failed-status: ${tokenResult.status}`;
            if (tokenResult.errors) {
                errorMessage += ` and errors: ${JSON.stringify(
                    tokenResult.errors
                )}`;
            }
            throw new Error(errorMessage);
        }
    }

    async initializeCard(payments) {
        const card = await payments.card();
        await card.attach('#card-container');
        return card;
        // status is either SUCCESS or FAILURE;
        // Helper method for displaying the Payment Status on the screen.
    }

    // Checkpoint 2.
    async handlePaymentMethodSubmission(event, paymentMethod) {
        event.preventDefault();
        try {
            // disable the submit button as we await tokenization and make a
            // payment request.
            const token = await this.tokenize(paymentMethod);
            const paymentResults = await this.createPayment(token);
            await this.displayPaymentResults('SUCCESS');

            console.log('Payment Success', paymentResults);
        } catch (e) {
            await this.displayPaymentResults('FAILURE');
            console.log(e.message);
        }
    }

    isChangeAmountToggler() {
        this.is_change_amount = !this.is_change_amount;
    }

    async ngAfterViewInit() {
        if (!window['Square']) {
            throw new Error('Square.js failed to load properly');
        }
        const payments = window['Square'].payments(this.applicationId, this.locationId);
        let card;
        try {
            card = await this.initializeCard(payments);

        } catch (e) {
            console.error('Initializing Card failed', e);
            return;
        }

        const cardButton = document.getElementById('card-button') as HTMLButtonElement | null;
        cardButton.addEventListener('click', async (event) => {
            console.log(event);
            await this.handlePaymentMethodSubmission(event, card);
        });
    }

    onSubmitError() {
        // if nonce error
        this.paymentService.isPaymentProcessed.next(false);
        this.paymentService.isPaymentError.next(true);
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
